import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './root-reducer';

const middlewares = [];
const componsedEnhancers = compose(applyMiddleware(...middlewares, thunk));

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['buReducer', 'ppReducer'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = createStore(persistedReducer, undefined, componsedEnhancers);
export const persistedStore = persistStore(store);